const locale = {
  UNIVERSAL_LINKS: 'Universal links',
  UNIVERSAL_LINKS_SUBTITLE:
    'One link any number of people can open. Each person confirms their email before the verification starts.',
  CREATE_LINK: 'Create link',
  EDIT_LINK: 'Edit link',
  NAME: 'Name',
  NAME_PLACEHOLDER: 'For example, Website sign-up',
  LINK: 'Link',
  FLOW: 'Flow',
  SELECT_FLOW: 'Select a flow',
  APPLICATION: 'Application',
  SELECT_APPLICATION: 'Select an application',
  STATUS: 'Status',
  CREATED_BY: 'Created by',
  CREATED_AT: 'Created at',
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  COPY_LINK: 'Copy link',
  LINK_COPIED: 'Link copied',
  LINK_UNAVAILABLE: 'Public address not configured',
  ENABLE: 'Enable',
  DISABLE: 'Disable',
  EDIT: 'Edit',
  DELETE: 'Delete',
  DELETE_TITLE: 'Delete this universal link?',
  DELETE_TEXT:
    'The link stops working immediately for everyone it was shared with. People who are already in the middle of a verification are not affected.',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  CREATE: 'Create',
  EMPTY_TITLE: 'No universal links yet',
  EMPTY_TEXT: 'Create a link to let anyone start a verification on their own.',
  FLOW_CHANGE_WARNING:
    'Changing the flow affects only people who open the link from now on. Anyone already in the middle of a verification continues on the previous flow.',
  NAME_REQUIRED: 'Name is required',
  FLOW_REQUIRED: 'Flow is required',
  APPLICATION_REQUIRED: 'Application is required',
};

export default locale;
